const alphabet = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

export function randomAlphanumericName(prefix = "meme", extension = "jpg"): string {
  const bytes = new Uint8Array(14);
  crypto.getRandomValues(bytes);
  const suffix = Array.from(bytes, (byte) => alphabet[byte % alphabet.length]).join("");
  return `${prefix}-${suffix}.${extension.replace(/^\./, "")}`;
}

